import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ClientId } from '../model/enum';
import { LoginModel } from '../model/login-model';
import { RegisterModel } from '../model/register-model';
import { ResetPasswordModel } from '../model/reset-password-model';
import { ForgotPasswordModel } from '../model/forgot-password-model';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly url = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getClienteIdLocal() {
    return localStorage.getItem('clientId');
  }

  setClienteIdLocal(clientId: string) {
    localStorage.setItem('clientId', clientId);
  }

  verificaClientId(clientId: string): number {
    switch (clientId) {
      case 'ControLimit':
        return ClientId.ControLimit;
      case 'MetaFacil':
        return ClientId.MetaFacil;
      case 'CountDown':
        return ClientId.CountDown;
      case 'ProductControl':
        return ClientId.ProductControl;
      case 'TatuGestor':
        return ClientId.TatuGestor;
      case 'CartaoVirtual':
        return ClientId.CartaoVirtual;
      case 'JaAssistiu':
        return ClientId.JaAssistiu;
      default:
        return ClientId.MetaFacil;
    }
  }

  create(model: RegisterModel): Observable<RegisterModel> {
    return this.http.post<RegisterModel>(`${this.url}/register`, model);
  }

  login(model: LoginModel): Observable<{ redirectUrl: string }> {
    return this.http.post<{ redirectUrl: string }>(`${this.url}/login`, model, {
      withCredentials: true,
    });
  }

  forgotPassword(model: ForgotPasswordModel): Observable<any> {
    return this.http.post<any>(`${this.url}/forgot-password`, model);
  }

  resetPassword(model: ResetPasswordModel): Observable<any> {
    return this.http.post<any>(`${this.url}/reset-password`, model);
  }

  exchangeCodeForToken(code: string, clientId: number): Observable<any> {
    return this.http.get(
      `${this.url}/signin-google?code=${code}&clientId=${clientId}`,
      { withCredentials: true }
    );
  }

  isLogado() {
    return this.http.get<any>(`${this.url}/isLogado`);
  }
}
